import Mention from "@tiptap/extension-mention";

export const ForumMention = Mention.extend({
  addProseMirrorPlugins() {
    return [];
  },
}).configure({
  HTMLAttributes: {
    class: "forum-editor-mention",
  },
  renderText({ node }) {
    return `@${node.attrs.label ?? node.attrs.id ?? ""}`;
  },
  renderHTML({ options, node }) {
    return [
      "span",
      {
        ...options.HTMLAttributes,
        "data-id": node.attrs.id,
        "data-label": node.attrs.label,
      },
      `@${node.attrs.label ?? node.attrs.id ?? ""}`,
    ];
  },
});
